<div class="d-flex container">
  <div class="d-flex info-container" (click)="toggle()">
    <ion-label text-wrap id="name">{{ title }}</ion-label>
  </div>
  <ion-toggle [(ngModel)]="checked" (ngModelChange)="checkedChanged.emit($event)"></ion-toggle>
</div>
